<div class="group-widget-container">
  <ng-content />
</div>
